<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-button-goto [ttText]="'producteans_new'" (ttClick)="goToFunc('productean')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListProductEans"></tt-list>
</tt-page>
